import { Outlet, createFileRoute } from '@tanstack/react-router';
import styles from './index.module.css';

export const Route = createFileRoute('/_embaUserLayout/_learnerLayout')({
  component: LayoutComponent,
});

// Storybookでも使うのでchildrenを受け取れるようにしている
export function LayoutComponent({ children }: { children?: React.ReactNode }) {
  return (
    <div className={styles.learnerLayout}>
      <div className={styles.main}>{children || <Outlet />}</div>
    </div>
  );
}
